import { Controller } from "@hotwired/stimulus"
import { loadScript } from "@paypal/paypal-js"

export default class extends Controller {
  static values = {
    // PayPal SDK parameters
    clientId: String,
    locale: String,
    currency: String,

    // Message parameters
    amount: Number,
  }

  // Initialize the PayPal SDK & show button
  connect() {
    this
      .#insertScript()
      .then(this.#initPayLater)
      .catch(e => console.error("PayPal pay later error", e))
  }

  disconnect() {
    this.element.innerHTML = ""
  }

  // Insert PayPal’s script
  #insertScript = () => {
    return loadScript({
      "client-id": this.clientIdValue,
      locale: this.localeValue,
      currency: this.currencyValue,
      components: "messages",
    })
  }

  #initPayLater = () => {
    if (window.paypal.Messages ) {
      window.paypal.Messages({
        amount: this.amountValue,
        style: {
          layout: "text",
          logo: {type: "inline"},
          text: {
            align: "center",
          },
        }
      }).render(this.element)
    }

    return Promise.resolve()
  }
}
